'use strict';

var React = require('react');

function mirror(o) {
  return o;
}

module.exports = function mapSelf(children) {
  // return ReactFragment
  return React.Children.map(children, mirror);
};


//////////////////
// WEBPACK FOOTER
// ./~/_rc-util@3.4.1@rc-util/lib/Children/mapSelf.js
// module id = 818
// module chunks = 0